import { router } from 'expo-router';
import { useCallback, useRef } from 'react';

import { useCloseStoreLocator } from './use-close-store-locator';

/**
 * Details is a pane of the locator rather than a route of its own, so how it closes depends
 * on how it opened. A guest who picked a store off the list is dismissing the pane and wants
 * the list back, which is just the param going away. A guest who landed on the details
 * themselves — a deep link, or the old details URL forwarding here — has no list behind them,
 * so closing leaves the locator the same way its own header does.
 *
 * @param storeDetailsId The store the locator is currently showing details for, if any.
 */
export function useCloseStoreDetails(storeDetailsId: string | undefined) {
  // Whether the locator got to show its list before details did. Read once: every later open
  // comes from the guest being on the locator, whatever the list is showing by then.
  const hasListBehind = useRef(!storeDetailsId);
  const closeStoreLocator = useCloseStoreLocator();

  return useCallback(() => {
    if (hasListBehind.current) {
      // The guest's selection is deliberately left as it was.
      router.setParams({ storeId: undefined });
      return;
    }

    closeStoreLocator();
  }, [closeStoreLocator]);
}
